// @flow

import * as React from 'react';
import {AlignBox} from 'sail/Align';
import Box from 'sail/Box';
import Select, {SelectOption} from 'sail/Select';
import {Subheading, SubheadingTextProps} from 'sail/Text';
import {useContentGroup} from './ContentGroupContext';

type DropDownSelectorProps = {|
  label?: string,
|};

export const DropDownSelector = ({label}: DropDownSelectorProps) => {
  const {items, onItemSelected, selectedItem} = useContentGroup();

  const handleChange = (id: string) => {
    const newItem = items.find((item) => item.id === id);
    if (newItem) {
      onItemSelected(newItem);
    }
  };

  return (
    <label>
      <Box
        divider={{color: 'light', width: 1, side: 'bottom'}}
        style={{height: '52px', marginLeft: '1px'}} // 1px margin so divider is not cut-off in a section
        flex={{alignItems: 'center'}}
      >
        <AlignBox reference={SubheadingTextProps}>
          {label && (
            <Box padding={{right: 12}}>
              <Subheading>{label}:</Subheading>
            </Box>
          )}
          <Select onChange={handleChange} value={selectedItem.id}>
            {items.map((item) => (
              <SelectOption key={item.id} label={item.title} value={item.id} />
            ))}
          </Select>
        </AlignBox>
      </Box>
    </label>
  );
};
